import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class Messages extends Component {
  render(){
    const { classes, theme, location } = this.props;
    return(
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          The messaging section of the DSN App lets you go to any of your dating profiles all from one screen. Just tap a button below to see it in action.
        </Typography>
        <br/>
        <Button onClick={() => {this.props.changeRoute("/console/my_profiles");}} className={classes.button} raised color="primary">
          Match
        </Button>
        <Button onClick={() => {this.props.changeRoute("/console/my_profiles");}} className={classes.button} raised color="primary">
          POF
        </Button>
        <Button onClick={() => {this.props.changeRoute("/console/my_profiles");}} className={classes.button} raised color="primary">
          Zoosk
        </Button>
        <Button onClick={() => {this.props.changeRoute("/console/my_profiles");}} className={classes.button} raised color="primary">
          OkCupid
        </Button>
      </div>
    );
  }
}
//<Hits hitComponent={Item}/>
function mapStateToProps(state) {
    return {
        customer_number: state.customer.number, 
        project_id: state.prefix.project_id,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Messages)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Communication/scenes/Messages/index.js